module.exports = __webpack_public_path__ + "img/Icons-02.417ce1d5.svg";